(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gg-gift-finder"] && !Shopify.designMode) return;
  try {
    
  /* Shopify runs this once per section TYPE. Every [data-gg-finder] on the page gets its own
     state (init), and the document-level listeners below are registered once. */
  (function () {
    'use strict';
    if (window.__ggFinderBooted) return;
    window.__ggFinderBooted = true;

    var WORDS = ['no', 'one', 'two', 'three', 'four'];
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function num(v, d) { return v === undefined || v === '' || isNaN(+v) ? d : +v; }
    function plural(n, word) { return n + ' ' + word + (n === 1 ? '' : 's'); }
    function makeMoney(currency) {
      return function (cents) {
        cents = Math.round(+cents || 0);
        var d = cents % 100 ? 2 : 0;
        try {
          return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency, minimumFractionDigits: d, maximumFractionDigits: d }).format(cents / 100);
        } catch (e) {
          var amount = (cents / 100).toFixed(d);
          return currency === 'USD' ? '$' + amount : amount + ' ' + currency;
        }
      };
    }
    function finders() { return [].slice.call(document.querySelectorAll('[data-gg-finder]')); }

    function init(root) {
      if (!root || root.dataset.ggReady) return;
      root.dataset.ggReady = '1';

      var $ = function (s) { return root.querySelector(s); };
      var $$ = function (s) { return [].slice.call(root.querySelectorAll(s)); };
      var builder = root.dataset.builder || '/pages/leather-corporate-gifts';
      var method = root.dataset.method || 'laser';
      var currency = root.dataset.currency || 'USD';
      var money = makeMoney(currency);
      var cards = $$('[data-gg-card]');
      var state = { category: 'all', budget: 'all', selected: [] };

      /* Budget limits are set in the store currency; convert them for the visitor's market currency. */
      var rate = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
      var low = num(root.dataset.low, 10000), high = num(root.dataset.high, 20000);
      if (rate !== 1) {
        low = Math.round(low * rate / 100) * 100;
        high = Math.round(high * rate / 100) * 100;
        var bl = $('[data-gg-budget="low"]'), bm = $('[data-gg-budget="mid"]'), bh = $('[data-gg-budget="high"]');
        if (bl) bl.textContent = 'Under ' + money(low);
        if (bm) bm.textContent = money(low) + '–' + money(high);
        if (bh) bh.textContent = 'Over ' + money(high);
      }

      function quote(list) {
        var v = list.map(function (c) { return [+c.dataset.variant, 1]; });
        if (!v.length) return builder + '#builder';
        var gb = btoa(JSON.stringify({ v: v, m: method }));
        return builder + '?gb=' + encodeURIComponent(gb) + '#builder';
      }

      function inBudget(cents) {
        if (state.budget === 'low') return cents < low;
        if (state.budget === 'mid') return cents >= low && cents <= high;
        if (state.budget === 'high') return cents > high;
        return true;
      }

      function filter() {
        var n = 0;
        cards.forEach(function (c) {
          var ok = (state.category === 'all' || c.dataset.category === state.category) && inBudget(+c.dataset.price);
          c.hidden = !ok;
          if (ok) n++;
        });
        var count = $('[data-gg-count]');
        if (count) count.textContent = plural(n, 'gift');
        var empty = $('[data-gg-empty]');
        if (empty) empty.hidden = n > 0;
        $$('[data-gg-category]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.ggCategory === state.category)); });
        $$('[data-gg-budget]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.ggBudget === state.budget)); });
        [].slice.call(document.querySelectorAll('[data-gg-recipient]')).forEach(function (a) {
          var on = a.dataset.ggRecipient === state.category;
          a.classList.toggle('is-active', on);
          if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
        });
      }

      function setHelp(initial) {
        var help = $('[data-gg-help]'); if (!help) return;
        var n = state.selected.length;
        if (!n) help.textContent = 'Choose up to four gifts using the Compare checkboxes.';
        else if (initial) help.textContent = 'A starting comparison of ' + WORDS[n] + ' gift' + (n === 1 ? '' : 's') + '. Use “Compare” on any product to make your own shortlist.';
        else help.textContent = plural(n, 'gift') + ' selected. Your comparison can include gifts from every budget and recipient group.';
      }

      function dash(s) { return s ? esc(s) : '—'; }

      function render() {
        cards.forEach(function (c) {
          var box = c.querySelector('[data-gg-compare]');
          if (box) box.checked = state.selected.indexOf(c) > -1;
        });
        var table = $('[data-gg-table]');
        var ps = state.selected;
        if (table) {
          if (!ps.length) {
            table.innerHTML = '<caption style="padding:35px">No gifts selected. Choose up to four using the Compare checkboxes above.</caption>';
          } else {
            var rows = [
              ['Best for', function (c) { return dash(c.dataset.best); }],
              ['Size / capacity', function (c) { return dash(c.dataset.size); }],
              ['Retail price / piece', function (c) { return '<span class="gg-table-price">' + money(c.dataset.price) + ' ' + esc(currency) + '</span>'; }],
              ['Configuration', function (c) { return dash(c.dataset.variantTitle); }],
              ['Logo options', function () { return esc(root.dataset.logoNote || 'Laser engraving or heat deboss, confirmed in your proof.'); }],
              ['Before you choose', function (c) { return dash(c.dataset.consider); }]
            ];
            table.innerHTML =
              '<thead><tr><th scope="col">Your shortlist</th>' +
              ps.map(function (c) {
                var im = c.dataset.image ? '<img src="' + esc(c.dataset.image) + '" alt="" width="90" height="90" loading="lazy">' : '';
                return '<th scope="col">' + im + esc(c.dataset.name) + '</th>';
              }).join('') +
              '</tr></thead><tbody>' +
              rows.map(function (r) { return '<tr><th scope="row">' + r[0] + '</th>' + ps.map(function (c) { return '<td>' + r[1](c) + '</td>'; }).join('') + '</tr>'; }).join('') +
              '</tbody>';
          }
        }
        /* Final CTA: carry the shortlist; with nothing selected restore the button's own link and note. */
        var url = quote(ps);
        [].slice.call(document.querySelectorAll('[data-gg-quote-all]')).forEach(function (a) {
          if (a.dataset.ggHref == null) a.dataset.ggHref = a.getAttribute('href') || '';
          a.setAttribute('href', ps.length ? url : a.dataset.ggHref);
        });
        [].slice.call(document.querySelectorAll('[data-gg-transfer-note]')).forEach(function (p) {
          if (p.dataset.ggDefault == null) p.dataset.ggDefault = p.textContent;
          p.textContent = ps.length
            ? plural(ps.length, 'selected gift') + ' carry over as one of each. Review quantities and the logo method in the builder.'
            : p.dataset.ggDefault;
        });
        var pr = $('[data-gg-print]'); if (pr) pr.disabled = !ps.length;
        var cl = $('[data-gg-clear]'); if (cl) cl.disabled = !ps.length;
      }

      function toast(msg) {
        var t = $('[data-gg-toast]'); if (!t) return;
        t.textContent = msg;
        clearTimeout(t._timer);
        t._timer = setTimeout(function () { t.textContent = ''; }, 4000);
      }

      /* preselect: first gift from each recipient group, up to N (none when the comparison is off) */
      var pre = parseInt(root.dataset.preselect, 10); if (isNaN(pre)) pre = 3;
      if (!$('[data-gg-table]')) pre = 0;
      var seen = {};
      cards.forEach(function (c) {
        if (state.selected.length < pre && !seen[c.dataset.category]) { seen[c.dataset.category] = 1; state.selected.push(c); }
      });

      $$('[data-gg-budget]').forEach(function (b) { b.addEventListener('click', function () { state.budget = b.dataset.ggBudget; filter(); }); });
      $$('[data-gg-category]').forEach(function (b) { b.addEventListener('click', function () { state.category = b.dataset.ggCategory; filter(); }); });
      var reset = $('[data-gg-reset]');
      if (reset) reset.addEventListener('click', function () {
        state.category = 'all'; state.budget = 'all'; filter();
        var first = $('[data-gg-category="all"]'); if (first) first.focus();
      });

      cards.forEach(function (c) {
        var box = c.querySelector('[data-gg-compare]');
        if (box) box.addEventListener('change', function () {
          var i = state.selected.indexOf(c);
          if (box.checked && i < 0 && state.selected.length >= 4) { box.checked = false; toast('Compare up to four gifts. Remove one to add another.'); return; }
          if (box.checked && i < 0) state.selected.push(c);
          if (!box.checked && i > -1) state.selected.splice(i, 1);
          setHelp(false);
          render();
        });

        var sel = c.querySelector('[data-gg-variant]');
        if (sel) sel.addEventListener('change', function () {
          var o = sel.options[sel.selectedIndex];
          if (!o || o.disabled) return;
          c.dataset.variant = o.value;
          c.dataset.price = o.dataset.price;
          c.dataset.variantTitle = o.dataset.title || '';
          if (o.dataset.thumb) c.dataset.image = o.dataset.thumb;
          var price = c.querySelector('[data-gg-price]');
          if (price) price.innerHTML = money(o.dataset.price) + '<small>' + esc(currency) + ' / piece</small>';
          var img = c.querySelector('.gg-card__photo img');
          if (img && o.dataset.image) { img.removeAttribute('srcset'); img.src = o.dataset.image; }
          var q = c.querySelector('[data-gg-quote]');
          if (q) q.href = quote([c]);
          /* no re-filter here: the card the visitor is editing stays visible and keeps focus */
          render();
        });
      });

      var clear = $('[data-gg-clear]');
      if (clear) clear.addEventListener('click', function () {
        state.selected = [];
        setHelp(false);
        render();
      });

      /* Print only the comparison: hide every sibling along the path from the table to <body>
         (display:none, so no blank pages), and clean up on afterprint (window.print() does not block on mobile). */
      var printBtn = $('[data-gg-print]');
      var printMarked = [];
      function printDone() {
        document.documentElement.classList.remove('gg-print-compare');
        printMarked.forEach(function (n) { n.classList.remove('gg-print-hide'); });
        printMarked = [];
        window.removeEventListener('afterprint', printDone);
      }
      if (printBtn) printBtn.addEventListener('click', function () {
        printDone();
        var target = $('[data-gg-compare-section]');
        if (!target) return;
        for (var el = target; el && el.parentElement && el !== document.body; el = el.parentElement) {
          [].forEach.call(el.parentElement.children, function (s) {
            if (s !== el) { s.classList.add('gg-print-hide'); printMarked.push(s); }
          });
        }
        document.documentElement.classList.add('gg-print-compare');
        window.addEventListener('afterprint', printDone);
        window.print();
      });

      root.__gg = {
        setCategory: function (cat) { state.category = cat || 'all'; state.budget = 'all'; filter(); },
        showAll: function () { state.category = 'all'; state.budget = 'all'; filter(); },
        render: render
      };
      window.__ggFinder = root.__gg;

      filter();
      setHelp(true);
      render();
    }

    /* Recipient cards (Recipients section) set the filter in every finder on the page */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-gg-recipient]');
      if (!a) return;
      finders().forEach(function (r) { if (r.__gg) r.__gg.setCategory(a.dataset.ggRecipient); });
    });

    function boot() { finders().forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

    /* Theme editor */
    document.addEventListener('shopify:section:load', function (e) {
      [].slice.call(e.target.querySelectorAll('[data-gg-finder]')).forEach(init);
      /* a reloaded final CTA section gets its shortlist back from the finder */
      if (e.target.querySelector('[data-gg-quote-all]')) {
        finders().forEach(function (r) { if (r.__gg) r.__gg.render(); });
      }
    });
    document.addEventListener('shopify:block:select', function (e) {
      var c = e.target.closest && e.target.closest('[data-gg-card]');
      if (!c || !c.hidden) return;
      var r = c.closest('[data-gg-finder]');
      if (r && r.__gg) r.__gg.showAll();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
